module.exports = __webpack_public_path__ + "static/media/BIRMINGHAM_ESOL_LOGO.675e1f82.png";